export default __webpack_public_path__ + "static/media/ic_next_white.8671107d.svg";